import React from 'react';

const XSearchScheduleList = ({ 
  schedules = [], 
  warnings = {},
  onEdit, 
  onDelete,
  deletingScheduleId 
}) => {
  const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  const formatDays = (daysOfWeek) => {
    if (!daysOfWeek || daysOfWeek.length === 0) {
      return 'Every day';
    }
    return daysOfWeek.map(day => dayNames[day]).join(', ');
  };

  const formatCadence = (value, unit) => {
    const singularUnit = value === 1 ? unit.slice(0, -1) : unit;
    return `Every ${value} ${singularUnit}`;
  };

  if (schedules.length === 0) {
    return (
      <div className="alert alert-info mb-0">
        <i className="bi bi-info-circle me-2"></i>
        No schedules configured. Click "Add Schedule" to create one.
      </div>
    );
  }

  return (
    <div className="list-group">
      {schedules.map((schedule) => {
        const scheduleWarnings = warnings[schedule.schedule_id] || [];
        
        return (
          <div key={schedule.schedule_id} className="list-group-item">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div className="flex-grow-1">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span className="badge bg-primary">
                    {formatCadence(schedule.cadence_value, schedule.cadence_unit)}
                  </span>
                  {schedule.is_active ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-secondary">Inactive</span>
                  )}
                </div>
                
                <div className="small text-muted">
                  <div>
                    <i className="bi bi-clock me-1"></i>
                    {schedule.all_day ? (
                      <span>All day (24/7)</span>
                    ) : (
                      <span>Time window: {schedule.start_time} - {schedule.end_time} EST</span>
                    )}
                  </div>
                  <div>
                    <i className="bi bi-calendar me-1"></i>
                    Days: {formatDays(schedule.days_of_week)}
                  </div>
                  {schedule.created_at && (
                    <div>
                      <i className="bi bi-calendar-plus me-1"></i>
                      Created: {new Date(schedule.created_at).toLocaleString()}
                    </div>
                  )}
                </div>

                {scheduleWarnings.length > 0 && (
                  <div className="alert alert-warning mt-2 mb-0 py-2">
                    <small>
                      <i className="bi bi-exclamation-triangle me-1"></i>
                      <strong>Overlap Warning:</strong>
                      <ul className="mb-0 mt-1 ps-3">
                        {scheduleWarnings.map((warning, idx) => (
                          <li key={idx}>{warning}</li>
                        ))}
                      </ul>
                    </small>
                  </div>
                )}
              </div>

              <div className="btn-group btn-group-sm ms-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => onEdit(schedule)}
                  title="Edit schedule"
                >
                  <i className="bi bi-pencil"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => onDelete(schedule.schedule_id)}
                  disabled={deletingScheduleId === schedule.schedule_id}
                  title="Delete schedule"
                >
                  {deletingScheduleId === schedule.schedule_id ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    <i className="bi bi-trash"></i>
                  )}
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default XSearchScheduleList;
